import React from 'react';
import PropTypes from 'prop-types';

import {TopBar, LeftBar, Chip} from './card.styled';

export const TopBarAndChip = ({cardDisabled, isSelected, isFavoured}) => {
	return (
		<TopBar>
			<LeftBar cardDisabled={cardDisabled} isSelected={isSelected} isFavoured={isFavoured} />
			<Chip cardDisabled={cardDisabled} isSelected={isSelected} isFavoured={isFavoured} />
		</TopBar>
	);
};

TopBarAndChip.propTypes = {
	/**
	 * toggles selected visual on card
	 */
	isSelected: PropTypes.bool,
	/**
	 * toggles favoured visual on card
	 */
	isFavoured: PropTypes.bool,
	/**
	 * toggles disabled visual on card
	 */
	cardDisabled: PropTypes.bool,
};
